// DS: PO44
/** Popup telling users they've successfully verified their email address */ import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ArtBrandedDesktopPopup, ArtBrandedMobilePopup } from '../ArtBrandedPopup';
import Button from '../Button';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './VerificationSuccessfulPopup.scss';
const POPUP_ARTWORKS = [
    {
        imageSrc: Url.staticCDNLink('eclipse/popups/artworks/ellysiumn-1.png'),
        username: 'ellysiumn'
    }
];
const getRandomArtWork = ()=>{
    return POPUP_ARTWORKS[Math.floor(Math.random() * POPUP_ARTWORKS.length)];
};
const VerificationSuccessfulPopup = ()=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { imageSrc, username } = getRandomArtWork();
    const onClose = ()=>window.location.assign(Url.browseHomeLink());
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(ArtBrandedMobilePopup, {
            artImageSrc: Url.staticCDNLink('eclipse/popups/artworks/ellysiumn-1.png'),
            artAuthorUsername: 'ellysiumn',
            onClose: onClose,
            popupProps: {
                isOpen: true,
                forceTheme: ThemeOptions.DARK
            }
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['title']
        }, t('verificationSuccessful.title')), /*#__PURE__*/ React.createElement("div", {
            className: s['text']
        }, t('verificationSuccessful.textOne')), /*#__PURE__*/ React.createElement("div", {
            className: s['text']
        }, t('verificationSuccessful.textTwo')), /*#__PURE__*/ React.createElement(Button, {
            href: Url.browseHomeLink(),
            view: "b1-1",
            className: s['browse-button'],
            height: "large",
            biData: BiData({
                evid: 234
            })
        }, t('verificationSuccessful.browse')));
    } else {
        return /*#__PURE__*/ React.createElement(ArtBrandedDesktopPopup, {
            artImageSrc: imageSrc,
            artAuthorUsername: username,
            title: t('verificationSuccessful.title'),
            tagline: t('verificationSuccessful.tagline'),
            titleClassName: s['title'],
            contentClassName: s['content'],
            popupProps: {
                isOpen: true
            },
            onClose: onClose
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['text']
        }, t('verificationSuccessful.textOne')), /*#__PURE__*/ React.createElement("div", {
            className: s['text']
        }, t('verificationSuccessful.textTwo')), /*#__PURE__*/ React.createElement(Button, {
            href: Url.browseHomeLink(),
            view: "b1-1",
            className: s['browse-button'],
            fullWidth: false,
            biData: BiData({
                evid: 234
            })
        }, t('verificationSuccessful.browse')));
    }
};
VerificationSuccessfulPopup.displayName = 'VerificationSuccessfulPopup';
export default VerificationSuccessfulPopup;

//# sourceMappingURL=VerificationSuccessfulPopup.js.map